import React, { useState, useEffect } from "react";
import { getRequest } from "services/api";

const StatisticsCards = () => {
  const [statistics, setStatistics] = useState({
    total_user: 0,
    total_working_today: 0,
    total_not_working_today: 0,
    average_check_in: null,
    earliest_check_in: null,
    latest_check_in: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const response = await getRequest("/ahr/statistics/total-data");
        if (response.success) {
          setStatistics(response.data);
        }
      } catch (error) {
        console.error("Error fetching statistics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, []);

  if (loading) {
    return (
      <div className="row row-deck row-cards mb-2">
        {[1, 2, 3].map((i) => (
          <div key={i} className="col-sm-6 col-lg-4 mb-4">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="subheader skeleton-text">Loading...</div>
                  <div className="ms-auto lh-1">
                    <div className="skeleton-text fs-2 fw-bold">0</div>
                  </div>
                </div>
                <div className="progress progress-sm mt-2 skeleton">
                  <div className="progress-bar" style={{ width: "0%" }}></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const workingPercentage = statistics.total_user > 0
    ? (statistics.total_working_today / statistics.total_user) * 100
    : 0;

  const notWorkingPercentage = statistics.total_user > 0
    ? (statistics.total_not_working_today / statistics.total_user) * 100
    : 0;

  return (
    <div className="row row-deck row-cards">
      <div className="col-sm-6 col-lg-4 mb-4">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="subheader">Total Team</div>
              <div className="ms-auto lh-1">
                <div className="text-primary fs-2 fw-bold">
                  {statistics.total_user}
                </div>
              </div>
            </div>
            <div className="progress progress-sm mt-2">
              <div
                className="progress-bar bg-primary"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-6 col-lg-4 mb-4">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="subheader">Working Today</div>
              <div className="ms-auto lh-1">
                <div className="text-success fs-2 fw-bold">
                  {statistics.total_working_today}
                </div>
              </div>
            </div>
            <div className="progress progress-sm mt-2">
              <div
                className="progress-bar bg-success"
                style={{ width: `${workingPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-6 col-lg-4 mb-4">
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <div className="subheader">Not Working Today</div>
              <div className="ms-auto lh-1">
                <div className="text-danger fs-2 fw-bold">
                  {statistics.total_not_working_today}
                </div>
              </div>
            </div>
            <div className="progress progress-sm mt-2">
              <div
                className="progress-bar bg-danger"
                style={{ width: `${notWorkingPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsCards;
